import styled from 'styled-components';


export const Container = styled.div`
  background-color:#EBEBEE;
  height:100%;
  width:100%;
  display: flex;
  flex-direction: column;
  
`;

